  export const calculateRowPosition = (index, column) => {
    if (column.length === 0) return 1;

    const getPosition = (i) => parseFloat(column[i]?.position || 0);
    if (index === 0) return getPosition(index) / 2;
    if (index === column.length) return getPosition(column.length - 1) + 1;
    return (getPosition(index - 1) + getPosition(index)) / 2;
  };

  export const calculateColumnPosition = (index, column) => {
    if (column.length === 0) return 1;
    
    const getPosition = (i) => parseFloat(column[i]?.position || 0);
    if (index === 0) return getPosition(index) / 2;
    if (index === column.length - 1) return getPosition(index) + 1;
    return (getPosition(index - 1) + getPosition(index)) / 2;
  };
